// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dot{
    height: 8px;
    width: 8px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 5px;
}

.red-dot{
    background-color: rgb(255, 36, 36);
}

.green-dot{
    background-color: rgb(44, 183, 187);
}

.head {
    background-color: #f1f1f1;
    padding: 8px 16px;
    font-weight: 600;
    font-size: 15px;
}
.value{
    padding: 8px 16px;
}
.vertRow{
    /* height: 30px; */
    border-bottom: 1px solid rgb(220, 219, 236);
    /* margin:0 5px; */
}
`, "",{"version":3,"sources":["webpack://./src/modules/ImageRegistry/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,2CAA2C;IAC3C,kBAAkB;AACtB","sourcesContent":[".dot{\n    height: 8px;\n    width: 8px;\n    border-radius: 50%;\n    display: inline-block;\n    margin-right: 5px;\n}\n\n.red-dot{\n    background-color: rgb(255, 36, 36);\n}\n\n.green-dot{\n    background-color: rgb(44, 183, 187);\n}\n\n.head {\n    background-color: #f1f1f1;\n    padding: 8px 16px;\n    font-weight: 600;\n    font-size: 15px;\n}\n.value{\n    padding: 8px 16px;\n}\n.vertRow{\n    /* height: 30px; */\n    border-bottom: 1px solid rgb(220, 219, 236);\n    /* margin:0 5px; */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
